module.exports = __webpack_public_path__ + "static/media/undraw_time_management.4b52209a.svg";